// import styled from "@emotion/styled";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
} from "@mui/material";
import "../../../scss/common.scss";
const DepartmentDialogBox = (props: any) => {
  const { modalOpen, setOpen } = props;
  return (
    <>
      <Dialog
        open={modalOpen}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          id="alert-dialog-title"
          className="Department-background fw-600 "
          sx={{ fontSize: "16px", mb: 3 }}
        >
          Department
        </DialogTitle>
        <DialogContent className="content">
          <DialogContentText id="alert-dialog-description">
            <Grid container>
              <Grid item md={12} xs={12} display="flex" flexDirection="column">
                <label>Name</label>
                <input
                  className="input br-5"
                  type="text"
                  placeholder="Enter Category Name"
                />
              </Grid>
              <Grid item md={12} xs={12} display="flex" flexDirection="column">
                <label className="text-color fw-500 fs-14">Url</label>
                <textarea className="input" placeholder="Write somthing" />
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Grid
            item
            md={12}
            xs={6}
            sx={{ display: "flex", justifyContent: "end" }}
          >
            <button
              className="btn cancel text-color btn-light-grey"
              onClick={() => setOpen(false)}
            >
              Cancel
            </button>
            <button
              className="btn cancel save btn-secondary"
            >
              Add
            </button>
          </Grid>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default DepartmentDialogBox;
